import axiosTraza from "global/helpers/axiosTraza";
import {
  LOGINTRAZA_ERROR,
  LOGINTRAZA_LOADING,
  LOGINTRAZA_SUCCESS,
  LOGOUTRAZA_USER,
} from "../../ActionTypes";

export const wsPostLoginTraza = ({ ingreso, sector }) =>
  (dispatch) => {
    dispatch({
      type: LOGINTRAZA_LOADING,
    });

    axiosTraza().then((respuesta) => {
      respuesta
        .post("/LoginTraza", {
          ingreso: ingreso,
          idsectoralta: parseInt(sector),
        })
        .then((res) => {
          dispatch({
            type: LOGINTRAZA_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: LOGINTRAZA_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsPostLogoutTraza = (id, { ingreso, sector }) =>
  (dispatch) => {
    dispatch({
      type: LOGINTRAZA_LOADING,
    });

    axiosTraza().then((respuesta) => {
      respuesta
        .put(`/LoginTraza/${id}`, {
          id: id,
          ingreso: ingreso,
          idsectoralta: parseInt(sector),
        })
        .then((res) => {
          dispatch({
            type: LOGINTRAZA_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: LOGINTRAZA_ERROR,

            payload: error,
          });
        });
    });
  };

export const logoutTraza = () => (dispatch) => {
  dispatch({ type: LOGOUTRAZA_USER });
};
